import { useState, useEffect, useMemo, useCallback } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { OverlayTrigger, Tooltip, Modal, Button, Spinner } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';

import { Row, Col, Container, Form, Table, Card, Accordion } from "react-bootstrap";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import CustomMultiSelectDropdown from "../../Component/Dropdown/index.js";
import plusIcon from '../../assets/images/plus-btn-green-icon.svg';
import minusIcon from '../../assets/images/minus-btn-green-icon.svg';
import exclamationIcon from '../../assets/images/exclamation-icon.svg';
import exclamationTraingleIcon from '../../assets/images/exclamation-traingle-icon.svg';
import cancelIconMdl from '../../assets/images/cancel-icon.svg';
import deleteIconMdl from '../../assets/images/delete-icon-web.svg';
import dataNameIcon from '../../assets/images/data-name-icon.svg';
import calendarIcon from '../../assets/images/calendar-iinput-icon.svg';
import arrowRightIcon from '../../assets/images/arrow-right-icon.svg';
import summaryIcon from '../../assets/images/view-summary-icon.svg';
import requestIcon from '../../assets/images/request.svg';

import {
    getEquipmentNumbers, getReBasins, getReBasinsOptions, getReEqipment, saveEqipment, getHose, saveHose,
    getHoseType, getCustomPackage, saveCustomPackageItems, getHSE, saveHSE, getLabItems, saveLabItems,
    getItems, saveItems, get3rdParty, save3rdParty, getSuppliedChainOptions, getFittinngType,
    deleteEquipment, getAllStatus, postReSupplyRequest
} from "../../Services/dashboard";

import { getRequestOverView, getRequestBasicInfo, getPriorityList, updateReSupplyRequest } from "../../Services/resupply.js";
import FullScreenLoader from "../../Component/Loader";
import Header from "../../Component/Header";

function Home() {
    const { deal_id, countryId, requestId, hs_deal_id } = useParams();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('equipment');
    const [isBasinLoading, setIsBasinLoading] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [isTabLoading, setIsTabLoading] = useState(true); // new state for table loader
    const [housesOptions, setHousesOptions] = useState([]);
    const [raNumbers, setRaNumbers] = useState([]);
    const [basins, setBasins] = useState([]);
    const [basinsOptions, setBasinsOptions] = useState([]);
    const [suppliedChainOptions, setSuppliedChainOptions] = useState([]);
    const [assetReset, setAssetReset] = useState(false);
    const [assetDelete, setAssetDelete] = useState(false);
    const [itemsData, setItemsData] = useState([]);
    const [equipmentIndexID, setEquipmentIndexID] = useState(null);
    const [pendingSelection, setPendingSelection] = useState(null);
    const [fittingOptions, setFittingOptions] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [priorityOptions, setPriorityOptions] = useState([]);
    const [isRequesting, setIsRequesting] = useState(false);
    const [requestBasicInfo, setRequestBasicInfo] = useState({});
    const [role, setRole] = useState(
        (typeof localStorage !== 'undefined' ? localStorage.getItem('userRole') : 'field tech')?.toLowerCase().trim() || 'field tech'
    );
    const [reSupplyErrors, setResupplyErrors] = useState({
        Needed_On: '',
        Status: '',
        priority: ''
    });

    // --- Tab data states ---
    const [equipments, setEquipments] = useState([]);
    const [houses, setHouses] = useState([]);
    const [customPackages, setCustomPackages] = useState([]);
    const [hseItems, setHseItems] = useState([]);
    const [labItems, setLabItems] = useState([]);
    const [thirdParty, setThirdParty] = useState([]);

    // --- Flags for lazy loading ---
    const [tabDataLoaded, setTabDataLoaded] = useState({
        equipment: false,
        house: false,
        items: false,
        custom: false,
        lap: false,
        hse: false,
        '3rdParty': false,
    });

    const [selectedCountry, setSelectedCountry] = useState({});
    const requestType = 'Resupply';
    const [reRequestDetails, setReRequestDetails] = useState({
        requested: false,
        Needed_On: "",
        Expected_Delivery_Date: "",
        delivery_date: "",
        Status: null,
        priority: "",
        comments: null,
        requestedBy: {
            FirstName: "",
            LastName: ""
        }
    });

    // --- Helper functions (memoized) ---
    const isEquipmentRowEmpty = useCallback((equipment) => {
        if (equipment.supplyChainAssetType?.trim()) return false;
        if (Number(equipment.OperationQuantity) > 0) return false;
        if (Number(equipment.SpareCount) > 0) return false;
        if (Number(equipment.NonBillableCount) > 0) return false;
        if (Number(equipment.SuppliedQuantity) > 0) return false;
        if (Number(equipment.requestedQuantity) > 0) return false;
        if (Number(equipment.approvedQuantity) > 0) return false;
        if (equipment.notes?.trim()) return false;
        if (equipment.Assets?.some(a => a.SuppliedBy?.value?.trim() || a.AssetDetails?.some(d => d.value))) return false;
        return true;
    }, []);

    const isHoseRowEmpty = useCallback((hose) => {
        if (hose.houseType?.trim()) return false;
        if (Number(hose.houseDiameter) > 0) return false;
        if (Number(hose.sectionLength) > 0) return false;
        if (hose.endFittingType1?.trim()) return false;
        if (hose.endFittingType2?.trim()) return false;
        if (Number(hose.quantity) > 0) return false;
        if (hose.suppliedBy?.value?.trim()) return false;
        return true;
    }, []);

    const isCustomRowEmpty = useCallback((custom) => {
        if (custom.itemName?.trim()) return false;
        if (Number(custom.quantity) > 0) return false;
        if (custom.suppliedBy?.trim()) return false;
        if (custom.notes?.trim()) return false;
        return true;
    }, []);

    // --- API fetch functions (updated to manage table loader) ---
    const fetchRequestOverView = useCallback(async () => {
        const payload = { Request_ID: requestId, JobDetails_ID: deal_id };
        const res = await getRequestOverView(localStorage.access_token, payload);
        if (res && res?.data?.status == 200) {
            const data = res.data.data;
            setReRequestDetails(prev => ({
                ...prev,
                Needed_On: data?.Needed_On ? data.Needed_On.split(" ")[0] : "",
                priority: data?.Priority,
                Expected_Delivery_Date: data?.Expected_Delivery_Date ? data.Expected_Delivery_Date.split("T")[0] : "",
                requestedBy: data?.Requested_User_Profile,
                Status: data?.Status
            }));
        }
    }, [requestId, deal_id]);

    const fetchRequestBasicInfo = useCallback(async () => {
        const res = await getRequestBasicInfo(localStorage.access_token, hs_deal_id);
        if (res && res?.data && res?.data?.status == 200) {
            setRequestBasicInfo(res?.data?.data[0]);
        }
    }, [hs_deal_id]);

    const fetchAllStatus = useCallback(async () => {
        const res = await getAllStatus(localStorage.access_token);
        if (res && res?.data?.status === 200) {
            const options = res.data.data.map(item => ({ value: item.ID, label: item.Status }));
            setStatusList(options);
        }
    }, []);

    const fetchPriorityOption = useCallback(async () => {
        const res = await getPriorityList(localStorage.access_token);
        if (res && res?.data && res?.data?.status == 200) {
            const options = res?.data?.data.map(item => ({
                value: item.ID,
                label: item.Priority
            }));
            setPriorityOptions(options);
        }
    }, []);

    const fetchEqipment = useCallback(async (equipment_id) => {
        setIsTabLoading(true);
        try {
            const res = await getReEqipment(localStorage.access_token, equipment_id, countryId, requestType, requestId);
            if (res.status === 200 && res.data?.status_code === 200) {
                const result = res.data?.result?.result || [];
                if (!result.length) {
                    setEquipments([{
                        isDeployed: false,
                        equipment_id: 0,
                        AssetSubType: [],
                        isSpare: true,
                        SpareCount: 0,
                        NonBillableCount: 0,
                        assetType: '',
                        supplyChainAssetType: '',
                        SalesQuantity: null,
                        OperationQuantity: null,
                        SuppliedQuantity: null,
                        requestedQuantity: null,
                        approvedQuantity: null,
                        availableQuantity: null,
                        expectedAvailableDate: null,
                        Supply_Chain_Asset_Type: "",
                        Assets: [
                            {
                                SuppliedBy: { value: "", label: "" },
                                AssetDetails: [{ value: null, label: "", AssetID: null }],
                                AssetCount: 0
                            }
                        ],
                        notes: ''
                    }]);
                } else {
                    const output = result
                        .filter(item => item?.is_delete !== true)
                        .map(item => ({
                            isDeployed: item?.isDeployed,
                            equipment_id: item.EquipmentID ?? 0,
                            AssetType: item.AssetType ?? '',
                            AssetSubType: item.AssetSubType ?? [],
                            isSpare: item.isSpare ?? true,
                            SpareCount: item.SpareCount ?? 0,
                            NonBillableCount: item.NonBillableCount ?? 0,
                            supplyChainAssetType: item.SupplyChainAssetType ?? '',
                            SalesQuantity: item.SalesQuantity ?? null,
                            OperationQuantity: item.OperationQuantity ?? null,
                            SuppliedQuantity: item.RS_SuppliedQuantity ?? null,
                            requestedQuantity: item.RS_RequestedQuantity ?? null,
                            approvedQuantity: item.RS_ApprovedQuantity ?? null,
                            availableQuantity: null,
                            expectedAvailableDate: item.RS_ExpectedAvailableDeliveryDate ?? null,
                            Status: item?.Status,
                            Assets: item.Assets?.length
                                ? item.Assets.map(asset => ({
                                    SuppliedBy: asset.SuppliedBy ? { value: asset.SuppliedBy, label: asset.SuppliedBy } : null,
                                    AssetCount: asset?.AssetCount ?? 0,
                                    AssetDetails: asset?.AssetDetails?.map(detail => ({
                                        AssetID: detail.AssetID ?? null,
                                        label: detail.AssetNo ?? '',
                                        value: detail.BCR_ID ?? null
                                    })) || []
                                }))
                                : [],
                            Notes: item.Notes ?? ''
                        }));
                    setEquipments(output);
                }
                setTabDataLoaded(prev => ({ ...prev, equipment: true }));
            }
        } catch (error) {
            console.error("Error fetching equipment:", error);
        } finally {
            setIsTabLoading(false);
        }
    }, [countryId, requestType, requestId]);

    const fetchHose = useCallback(async (hose_id) => {
        setIsTabLoading(true);
        try {
            const res = await getHose(localStorage.access_token, hose_id, countryId, requestType, requestId);
            if (res.status === 200 && res.data?.status_code === 200 && res.data.result?.length) {
                const formatted = res.data.result.map((item, index) => ({
                    index,
                    ID: item.ID,
                    isDeployed: item?.isDeployed,
                    houseType: item.HoseType ?? '',
                    houseDiameter: item.HoseDiameter ?? null,
                    sectionLength: item.SectionLength ?? null,
                    endFittingType1: item.EndFittingType1 ?? '',
                    endFittingType2: item.EndFittingType2 ?? '',
                    quantity: item.Quantity ?? null,
                    suppliedBy: item.SuppliedBy ? { value: item.SuppliedBy, label: item.SuppliedBy } : null,
                    Status: item.Status ?? ''
                }));
                setHouses(formatted);
            } else {
                setHouses([{
                    index: 0,
                    houseType: '',
                    houseDiameter: null,
                    sectionLength: null,
                    endFittingType1: '',
                    endFittingType2: "",
                    quantity: null,
                    suppliedBy: '',
                    ID: null,
                    isDeployed: false,
                    Status: ''
                }]);
            }
            setTabDataLoaded(prev => ({ ...prev, house: true }));
        } catch (err) {
            console.error("Error fetching hoses:", err);
        } finally {
            setIsTabLoading(false);
        }
    }, [countryId, requestType]);

    const fetchCustomPackage = useCallback(async (package_id) => {
        setIsTabLoading(true);
        try {
            const res = await getCustomPackage(localStorage.access_token, package_id, countryId, requestType, requestId);
            if (res.status === 200 && res.data?.status_code === 200 && res.data.result?.length) {
                const formatted = res.data.result.map((item, index) => ({
                    ID: item.ID,
                    index,
                    itemName: item.ItemName ?? '',
                    quantity: item.Quantity ?? null,
                    suppliedBy: item.SuppliedBy ?? '',
                    notes: item.Notes ?? '',
                    isDeployed: item?.isDeployed
                }));
                setCustomPackages(formatted);
            } else {
                setCustomPackages([{ index: 0, itemName: '', quantity: null, suppliedBy: '', notes: '', ID: null, isDeployed: false }]);
            }
            setTabDataLoaded(prev => ({ ...prev, custom: true }));
        } catch (error) {
            console.error("Error fetching custom packages:", error);
        } finally {
            setIsTabLoading(false);
        }
    }, [countryId, requestType]);

    const fetchHSEItems = useCallback(async (job_id) => {
        setIsTabLoading(true);
        try {
            const res = await getHSE(localStorage.access_token, job_id, countryId, requestType, requestId);
            if (res.status === 200 && res.data?.status_code === 200 && res.data.result) {
                const formatted = res.data.result.map((item, index) => ({
                    ID: item.ID ?? 0,
                    HSEItemID: item.HSEItemID ?? 0,
                    itemName: item.ItemName ?? "",
                    quantity: item.Quantity ?? "",
                    Notes: item.Notes ?? "",
                    isDeployed: item?.isDeployed,
                    suppliedBy: item.SuppliedBy ?? "",
                }));
                setHseItems(formatted);
            } else {
                setHseItems([{ index: 0, ID: 0, HSEItemID: 0, itemName: "", quantity: null, Notes: "", suppliedBy: "", isDeployed: false }]);
            }
            setTabDataLoaded(prev => ({ ...prev, hse: true }));
        } catch (error) {
            console.error("Error fetching HSE items:", error);
        } finally {
            setIsTabLoading(false);
        }
    }, [countryId, requestType]);

    const fetchLabItems = useCallback(async (job_id) => {
        setIsTabLoading(true);
        try {
            const res = await getLabItems(localStorage.access_token, job_id, countryId, requestType, requestId);
            if (res.status === 200 && res.data?.status_code === 200 && res.data.result) {
                const formatted = res.data.result.map((item, index) => ({
                    index,
                    ID: item.ID ?? null,
                    isDeployed: item.isDeployed,
                    LabItemsID: item.LabItemsID ?? null,
                    itemName: item.ItemName ?? "",
                    quantity: item.Quantity ?? null,
                    suppliedBy: item.SuppliedBy ?? "",
                }));
                setLabItems(formatted);
            } else {
                setLabItems([{ index: 0, ID: null, LabItemsID: 0, itemName: "", quantity: null, suppliedBy: "", isDeployed: false }]);
            }
            setTabDataLoaded(prev => ({ ...prev, lap: true }));
        } catch (error) {
            console.error("Error fetching lab items:", error);
        } finally {
            setIsTabLoading(false);
        }
    }, [countryId, requestType]);

    const fetchItems = useCallback(async (id) => {
        setIsTabLoading(true);
        try {
            const res = await getItems(localStorage.access_token, id, countryId, requestType, requestId);
            if (res.status === 200 && res.data?.status_code === 200) {
                setItemsData(res.data?.result);
                setTabDataLoaded(prev => ({ ...prev, items: true }));
            }
        } catch (error) {
            console.error("Error fetching items:", error);
        } finally {
            setIsTabLoading(false);
        }
    }, [countryId, requestType]);

    const fetchSuppliedOptions = useCallback(async () => {
        const res = await getSuppliedChainOptions(localStorage.access_token, countryId);
        if (res.status === 200 && res.data?.status_code === 200) {
            setSuppliedChainOptions(res.data?.result);
        }
    }, [countryId]);

    const fetchHoseTypeOptions = useCallback(async () => {
        const res = await getHoseType(localStorage.access_token, countryId);
        if (res.status === 200 && res.data?.status_code === 200) {
            const output = res.data?.result.map(item => ({ value: item.ID, label: item.HoseType }));
            setHousesOptions(output);
        }
    }, [countryId]);

    const fetchBasinsOptions = useCallback(async () => {
        const res = await getReBasinsOptions(localStorage.access_token, countryId, deal_id);
        if (res.status === 200 && res.data?.status_code === 200) {
            const output = res.data?.result.map(item => ({ value: item, label: item }));
            setBasinsOptions(output);
        }
    }, [countryId]);

    const fetchFittingOptions = useCallback(async () => {
        const res = await getFittinngType(localStorage.access_token, countryId);
        if (res.status === 200 && res.data?.status_code === 200) {
            setFittingOptions(res.data?.result);
        }
    }, [countryId]);

    const fetchRsNumber = useCallback(async (RsNumber, basin, equipmentIndex, assetIndex) => {
        setIsBasinLoading(true);
        const res = await getEquipmentNumbers(localStorage.access_token, RsNumber, basin, countryId);
        setIsBasinLoading(false);
        if (res.status === 200 && res.data?.status_code === 200) {
            const output = res.data?.result?.data?.map(item => ({ value: item.ID, label: item.AssetName }));
            const count = res.data?.result?.count || 0;
            setRaNumbers(output);
            setEquipments(prev => {
                const updated = [...prev];
                const target = { ...updated[equipmentIndex] };
                const updatedAssets = [...(target.Assets || [])];
                const asset = { ...updatedAssets[assetIndex] };
                asset.AssetCount = count;
                updatedAssets[assetIndex] = asset;
                target.Assets = updatedAssets;
                updated[equipmentIndex] = target;
                return updated;
            });
        }
    }, [countryId]);

    const fetchBasins = useCallback(async (assetType) => {
        setIsBasinLoading(true);
        const res = await getReBasins(localStorage.access_token, assetType, countryId, deal_id);
        setIsBasinLoading(false);
        if (res.status === 200 && res.data?.status_code === 200) {
            const output = res.data?.result.map(item => ({ value: item, label: item }));
            setBasins(output);
        }
    }, [countryId]);

    // --- Load initial data ---
    useEffect(() => {
        if (countryId && countryId !== 'undefined') {
            setSelectedCountry({ label: countryId, value: countryId });
        }
        fetchRequestBasicInfo();
        fetchRequestOverView();
        fetchAllStatus();
        fetchPriorityOption();
        fetchSuppliedOptions();
        fetchHoseTypeOptions();
        fetchBasinsOptions();
        fetchFittingOptions();
        // Load initial equipment data
        if (deal_id) {
            fetchEqipment(deal_id);
        }
    }, [countryId, fetchRequestBasicInfo, fetchRequestOverView, fetchAllStatus, fetchPriorityOption,
        fetchSuppliedOptions, fetchHoseTypeOptions, fetchBasinsOptions, fetchFittingOptions, fetchEqipment, deal_id]);

    // --- Lazy load tab data when switching tabs ---
    useEffect(() => {
        if (!deal_id) return;
        const loadTabData = async () => {
            switch (activeTab) {
                case 'house':
                    if (!tabDataLoaded.house) await fetchHose(deal_id);
                    break;
                case 'items':
                    if (!tabDataLoaded.items) await fetchItems(deal_id);
                    break;
                case 'custom':
                    if (!tabDataLoaded.custom) await fetchCustomPackage(deal_id);
                    break;
                case 'lap':
                    if (!tabDataLoaded.lap) await fetchLabItems(deal_id);
                    break;
                case 'hse':
                    if (!tabDataLoaded.hse) await fetchHSEItems(deal_id);
                    break;
                default:
                    break;
            }
        };
        loadTabData();
    }, [activeTab, deal_id, tabDataLoaded, fetchHose, fetchItems, fetchCustomPackage, fetchLabItems, fetchHSEItems]);

    // --- Auto-select first Supplied By option when quantity is filled ---
    // Equipment tab
    useEffect(() => {
        if (!basinsOptions || basinsOptions.length === 0) return;
        let changed = false;
        const newEquipments = equipments.map(eq => {
            if (Number(eq.requestedQuantity) > 0) {
                const assets = eq.Assets || [];
                if (assets.length > 0 && !assets[0]?.SuppliedBy?.value) {
                    changed = true;
                    const newAssets = [...assets];
                    newAssets[0] = {
                        ...newAssets[0],
                        SuppliedBy: { value: basinsOptions[0].value, label: basinsOptions[0].label }
                    };
                    return { ...eq, Assets: newAssets };
                }
            }
            return eq;
        });
        if (changed) setEquipments(newEquipments);
    }, [basinsOptions, equipments]);

    // Hose tab
    useEffect(() => {
        if (!basinsOptions || basinsOptions.length === 0) return;
        let changed = false;
        const newHouses = houses.map(h => {
            if (Number(h.quantity) > 0 && !h.suppliedBy?.value) {
                changed = true;
                return { ...h, suppliedBy: { value: basinsOptions[0].value, label: basinsOptions[0].label } };
            }
            return h;
        });
        if (changed) setHouses(newHouses);
    }, [basinsOptions, houses]);

    // Custom Items tab
    useEffect(() => {
        if (!basinsOptions || basinsOptions.length === 0) return;
        let changed = false;
        const newCustom = customPackages.map(c => {
            if (Number(c.quantity) > 0 && !c.suppliedBy) {
                changed = true;
                return { ...c, suppliedBy: basinsOptions[0].value };
            }
            return c;
        });
        if (changed) setCustomPackages(newCustom);
    }, [basinsOptions, customPackages]);

    // Lab Items tab
    useEffect(() => {
        if (!basinsOptions || basinsOptions.length === 0) return;
        let changed = false;
        const newLab = labItems.map(l => {
            if (Number(l.quantity) > 0 && !l.suppliedBy) {
                changed = true;
                return { ...l, suppliedBy: basinsOptions[0].value };
            }
            return l;
        });
        if (changed) setLabItems(newLab);
    }, [basinsOptions, labItems]);

    // HSE tab
    useEffect(() => {
        if (!basinsOptions || basinsOptions.length === 0) return;
        let changed = false;
        const newHse = hseItems.map(h => {
            if (Number(h.quantity) > 0 && !h.suppliedBy) {
                changed = true;
                return { ...h, suppliedBy: basinsOptions[0].value };
            }
            return h;
        });
        if (changed) setHseItems(newHse);
    }, [basinsOptions, hseItems]);

    // Items tab (nested)
    useEffect(() => {
        if (!basinsOptions || basinsOptions.length === 0) return;
        let changed = false;
        const newItemsData = { ...itemsData };
        if (newItemsData.result) {
            newItemsData.result = newItemsData.result.map(category => {
                const newCategory = { ...category };
                // Main items
                if (newCategory.items) {
                    newCategory.items = newCategory.items.map(item => {
                        if (Number(item.Quantity) > 0 && !item.SuppliedBy) {
                            changed = true;
                            return { ...item, SuppliedBy: basinsOptions[0].value };
                        }
                        return item;
                    });
                }
                // Sub-category items
                if (newCategory.SubCategory) {
                    newCategory.SubCategory = newCategory.SubCategory.map(sub => {
                        if (sub.items) {
                            sub.items = sub.items.map(item => {
                                if (Number(item.Quantity) > 0 && !item.SuppliedBy) {
                                    changed = true;
                                    return { ...item, SuppliedBy: basinsOptions[0].value };
                                }
                                return item;
                            });
                        }
                        return sub;
                    });
                }
                return newCategory;
            });
        }
        if (changed) setItemsData(newItemsData);
    }, [basinsOptions, itemsData]);

    // --- Add blank asset row to equipments if needed (memoized effect) ---
    useEffect(() => {
        if (!equipments?.length) return;
        const updatedEquipments = equipments.map((equipment) => {
            const assets = equipment.Assets || [];
            const alreadyHasBlankRow = assets.some(
                (a) => !a?.SuppliedBy?.value && (!a.AssetDetails || !a.AssetDetails.filter(a => a.value !== null).length)
            );
            let updatedAssets = [...assets];
            const lastRowHasValidSupplier = assets[assets.length - 1]?.SuppliedBy?.value;
            if ((assets.length === 0 || lastRowHasValidSupplier) && !alreadyHasBlankRow) {
                updatedAssets.push({ SuppliedBy: null, AssetDetails: [] });
            }
            return { ...equipment, Assets: updatedAssets };
        });
        if (JSON.stringify(equipments) !== JSON.stringify(updatedEquipments)) {
            setEquipments(updatedEquipments);
        }
    }, [equipments]);

    // --- Handlers (memoized) ---
    const handleAddData = useCallback((type) => {
        if (type === 'equipment') {
            setEquipments(prev => [...prev, {
                isDeployed: false,
                equipment_id: null,
                AssetSubType: [],
                isSpare: true,
                SpareCount: 0,
                NonBillableCount: 0,
                assetType: '',
                supplyChainAssetType: '',
                SalesQuantity: '',
                OperationQuantity: null,
                SuppliedQuantity: null,
                requestedQuantity: null,
                approvedQuantity: null,
                availableQuantity: null,
                expectedAvailableDate: null,
                Assets: [{ SuppliedBy: { value: "", label: "" }, AssetDetails: [{ value: null, label: "", AssetID: null }], AssetCount: 0 }],
                notes: ''
            }]);
        } else if (type === 'house') {
            setHouses(prev => [...prev, { index: prev.length, houseType: '', houseDiameter: null, sectionLength: null, endFittingType1: '', endFittingType2: '', quantity: null, suppliedBy: '', ID: null, isDeployed: false }]);
        } else if (type === 'custom') {
            setCustomPackages(prev => [...prev, { index: prev.length, itemName: '', quantity: null, suppliedBy: '', notes: '', ID: null, isDeployed: false }]);
        } else if (type === 'lab') {
            setLabItems(prev => [...prev, { index: prev.length, ID: null, LabItemsID: 0, itemName: "", quantity: null, suppliedBy: "", isDeployed: false }]);
        } else if (type === 'hse') {
            setHseItems(prev => [...prev, { index: prev.length, ID: null, HSEItemID: 0, itemName: "", quantity: null, Notes: "", suppliedBy: "", isDeployed: false }]);
        } else if (type === '3rdParty') {
            setThirdParty(prev => [...prev, { index: prev.length, ID: null, BCR_ID: null, AssetName: "", Quantity: null, SuppliedBy: "" }]);
        }
    }, []);

    const handleRemoveData = useCallback((type, val) => {
        if (type === 'equipment') {
            setEquipmentIndexID(val);
            setAssetDelete(true);
        } else if (type === 'house') {
            setHouses(prev => prev.filter(item => (item.index !== undefined ? item.index !== val.index : item.ID !== val.ID)));
        } else if (type === 'custom') {
            setCustomPackages(prev => prev.filter(item => (item.index !== undefined ? item.index !== val.index : item.ID !== val.ID)));
        } else if (type === 'lab') {
            setLabItems(prev => prev.filter(item => (item.index !== undefined ? item.index !== val.index : item.ID !== val.ID)));
        } else if (type === 'hse') {
            setHseItems(prev => prev.filter(item => (item.index !== undefined ? item.index !== val.index : item.HSEItemID !== val.HSEItemID)));
        } else if (type === '3rdParty') {
            setThirdParty(prev => prev.filter(item => (item.index !== undefined ? item.index !== val.index : item.BCR_ID !== val.BCR_ID)));
        }
    }, []);

    const handleInputChange = useCallback((type, event, index) => {
        const { name, value } = event.target;
        if (type === 'equipment') {
            setEquipments(prev => {
                const temp = [...prev];
                const prevValue = temp[index][name];
                temp[index][name] = value;
                return temp;
            });
        } else if (type === "opsEquipment") {
            setEquipments(prev => {
                const temp = [...prev];
                const newValue = Number(value);
                const salesQty = Number(temp[index].requestedQuantity);
                temp[index][name] = newValue;
                const totalAllowed = Math.max(0, newValue - salesQty);
                let currentNonBillable = Number(temp[index].NonBillableCount);
                if (currentNonBillable > totalAllowed) currentNonBillable = totalAllowed;
                temp[index].SpareCount = Math.max(0, totalAllowed - currentNonBillable);
                temp[index].NonBillableCount = currentNonBillable;
                const prevValue = temp[index][name];
                if (name === 'SuppliedQuantity' && (value === '' || Number(value) === 0)) {
                    if (prevValue !== '' && Number(prevValue) !== 0) {
                        temp[index].Assets = temp[index].Assets.map(asset => ({
                            ...asset,
                            SuppliedBy: null,
                            AssetDetails: [],
                            AssetCount: 0
                        }));
                    }
                }
                return temp;
            });
        } else if (type === "adEquipment") {
            setEquipments(prev => {
                const temp = [...prev];
                const field = event.target.name;
                const enteredValue = Number(event.target.value);
                const salesQty = Number(temp[index].requestedQuantity);
                const opsQty = Number(temp[index].SuppliedQuantity);
                const totalAllowed = Math.max(0, opsQty - salesQty);
                if (field === "SpareCount") {
                    const newSpare = Math.min(enteredValue, totalAllowed);
                    temp[index].SpareCount = newSpare;
                    temp[index].NonBillableCount = Math.max(0, totalAllowed - newSpare);
                } else if (field === "NonBillableCount") {
                    const newNonBillable = Math.min(enteredValue, totalAllowed);
                    temp[index].NonBillableCount = newNonBillable;
                    temp[index].SpareCount = Math.max(0, totalAllowed - newNonBillable);
                }
                return temp;
            });
        }
        else if (type === 'house') {
            setHouses(prev => {
                const temp = [...prev];
                temp[index][name] = value;
                return temp;
            });
        } else if (type === 'custom') {
            setCustomPackages(prev => {
                const temp = [...prev];
                temp[index][name] = value;
                return temp;
            });
        } else if (type === "lap") {
            setLabItems(prev => {
                const temp = [...prev];
                temp[index][name] = value;
                return temp;
            });
        } else if (type === "hse") {
            setHseItems(prev => {
                const temp = [...prev];
                temp[index][name] = value;
                return temp;
            });
        } else if (type === "3rdParty") {
            setThirdParty(prev => {
                const temp = [...prev];
                temp[index][name] = value;
                return temp;
            });
        }
    }, []);

    const handleSelectChange = useCallback((type, selectedOption, index, fieldName) => {
        if (type === 'equipment') {
            setEquipments(prev => {
                const temp = [...prev];
                temp[index][fieldName] = selectedOption ? selectedOption.value : '';
                temp[index].Assets = [{ SuppliedBy: { value: "", label: "" }, AssetDetails: [{ value: null, label: "", AssetID: null }], AssetCount: 0 }];
                return temp;
            });
        } else if (type === 'house' || type === 'houseFitting1' || type === 'houseFitting2') {
            setHouses(prev => {
                const temp = [...prev];
                temp[index][fieldName] = selectedOption ? selectedOption.label : null;
                return temp;
            });
        } else if (type === 'houseSupplied') {
            setHouses(prev => {
                const temp = [...prev];
                temp[index][fieldName] = selectedOption || null;
                return temp;
            });
        } else if (type === 'custom') {
            setCustomPackages(prev => {
                const temp = [...prev];
                temp[index][fieldName] = selectedOption ? selectedOption.value : '';
                return temp;
            });
        } else if (type === "lapSelect") {
            setLabItems(prev => {
                const temp = [...prev];
                temp[index][fieldName] = selectedOption ? selectedOption.value : '';
                return temp;
            });
        } else if (type === "hse") {
            setHseItems(prev => {
                const temp = [...prev];
                temp[index][fieldName] = selectedOption ? selectedOption.value : '';
                return temp;
            });
        }
    }, []);

    const handleSuppliedEquipment = useCallback((type, selectedOption, equipmentIndex, assetIndex) => {
        if (type === "raNumber") {
            setEquipments(prev => {
                const temp = [...prev];
                temp[equipmentIndex].Assets[assetIndex].AssetDetails = selectedOption;
                return temp;
            });
        } else if (type === "basin") {
            setEquipments(prev => {
                const temp = [...prev];
                temp[equipmentIndex].Assets[assetIndex].SuppliedBy = selectedOption;
                temp[equipmentIndex].Assets[assetIndex].AssetDetails = [];
                temp[equipmentIndex].Assets[assetIndex].assetKey = Date.now();
                return temp;
            });
        }
    }, []);

    const handleToggle = useCallback((index) => {
        setEquipments(prev =>
            prev.map((item, i) => i === index ? { ...item, isSpare: !item.isSpare } : item)
        );
    }, []);

    const handleCreateFittingOption = useCallback((inputValue, index) => {
        const newOption = { label: inputValue.trim(), value: inputValue.trim() };
        setFittingOptions(prev => [...prev, newOption]);
        handleSelectChange("houseFitting1", newOption, index, "endFittingType1");
    }, [handleSelectChange]);

    const handleCreateFittingOption2 = useCallback((inputValue, index) => {
        const newOption = { label: inputValue.trim(), value: inputValue.trim() };
        setFittingOptions(prev => [...prev, newOption]);
        handleSelectChange("houseFitting2", newOption, index, "endFittingType2");
    }, [handleSelectChange]);

    const handleCreateHouseOption = useCallback((inputValue, index) => {
        const newOption = {
            value: inputValue.trim(),
            label: inputValue.trim()
        };
        setHousesOptions(prev => [...prev, newOption]);
        handleSelectChange("house", newOption, index, "houseType");
    }, [handleSelectChange]);

    const hndleEquipmentDelete = useCallback(async () => {
        setShowLoader(true);
        const payload = { equipment_id: equipmentIndexID?.equipment_id };
        const res = await deleteEquipment(localStorage.access_token, payload);
        setShowLoader(false);
        if (res?.data?.status_code === 200) {
            toast.success(res?.data?.message);
        }
        setEquipments(prev => prev.filter(item => {
            if (item.index !== undefined) return item.index !== equipmentIndexID.index;
            return item.equipment_id !== equipmentIndexID.equipment_id;
        }));
    }, [equipmentIndexID]);

    const handleItemsInputChange = useCallback((categoryIndex, identifier1, identifier2, field, value, isSubCategory = false) => {
        setItemsData(prev => {
            const updatedData = {
                ...prev, result: prev.result.map((category, catIndex) => {
                    if (catIndex === categoryIndex) {
                        if (isSubCategory && Array.isArray(category.SubCategory)) {
                            const subCategoryIndex = identifier1;
                            const itemIndex = identifier2;
                            return {
                                ...category,
                                SubCategory: category.SubCategory.map((subCategory, subCatIndex) => {
                                    if (subCatIndex === subCategoryIndex) {
                                        return {
                                            ...subCategory,
                                            items: subCategory.items.map((item, idx) => {
                                                if (idx === itemIndex) {
                                                    return { ...item, [field]: field === 'Quantity' ? parseInt(value) || 0 : value?.value || value };
                                                }
                                                return item;
                                            })
                                        };
                                    }
                                    return subCategory;
                                })
                            };
                        } else if (!isSubCategory) {
                            const itemIndex = identifier1;
                            return {
                                ...category,
                                items: category.items.map((item, idx) => {
                                    if (idx === itemIndex) {
                                        return { ...item, [field]: field === 'Quantity' ? parseInt(value) || 0 : value?.value || value };
                                    }
                                    return item;
                                })
                            };
                        }
                    }
                    return category;
                })
            };
            return updatedData;
        });
    }, []);

    const handleReDetailsChange = useCallback((e, type) => {
        if (type === 'Status' || type === 'priority') {
            setReRequestDetails(prev => ({ ...prev, [type]: e }));
        } else {
            const { name, value } = e.target;
            setReRequestDetails(prev => ({ ...prev, [name]: value }));
        }
    }, []);

    const handleTablClick = async (tab) => {
        if (reRequestDetails?.Status == 'Deployed') {
            setActiveTab(tab);
        } else {
            setActiveTab(tab);
            const saveSuccessful = await handleSave();
            const res = await fetchRequestOverView()
            if (!saveSuccessful) return;
        }
    }

    // --- Save handlers (memoized) ---
    const handleSave = useCallback(async () => {
        let validationPassed = true;

        if (activeTab === 'equipment') {
            const output = equipments.map(item => ({
                EquipmentID: item.equipment_id || null,
                AssetType: item.AssetType || "",
                isSpare: item.isSpare,
                isDeployed: false,
                SalesQuantity: item.SalesQuantity || null,
                OperationQuantity: item.OperationQuantity || null,
                SuppliedQuantity: null,
                Supply_Chain_Asset_Type: item.supplyChainAssetType,
                NonBillableCount: item.NonBillableCount || 0,
                "RS_RequestedQuantity": item.requestedQuantity || 0,
                "ResupplyDetailsID": requestId,
                "RS_ApprovedQuantity": item.approvedQuantity || 0,
                "RS_SuppliedQuantity": item.SuppliedQuantity || null,
                "RS_ExpectedAvailableDeliveryDate": item.expectedAvailableDate || null,
                SpareCount: item.SpareCount || 0,
                Notes: item.Notes || "",
                Assets: item.Assets.map(asset => ({
                    SuppliedBy: asset.SuppliedBy?.value || "",
                    AssetDetails: asset.AssetDetails.map(detail => ({
                        AssetID: detail.AssetID || null,
                        BCR_ID: detail.value || null,
                        AssetNo: detail.label || ""
                    }))
                }))
            }));


            const cleanedData = output.filter(equipment => {
                const hasMain = (equipment.OperationQuantity && Number(equipment.OperationQuantity) > 0) ||
                    (equipment.SuppliedQuantity && Number(equipment.SuppliedQuantity) > 0) ||
                    (equipment.RS_RequestedQuantity && Number(equipment.RS_RequestedQuantity) > 0) ||
                    (equipment.RS_ApprovedQuantity && Number(equipment.RS_ApprovedQuantity) > 0) ||
                    equipment.Supply_Chain_Asset_Type ||
                    !!equipment.AssetType ||
                    !!equipment.SalesQuantity;
                const hasAsset = equipment.Assets?.some(asset =>
                    !!asset.SuppliedBy?.trim() ||
                    asset.AssetDetails?.some(d => d.BCR_ID !== null && d.BCR_ID !== "" && d.BCR_ID !== undefined)
                );
                return hasMain || hasAsset;
            });

            if (cleanedData.length === 0) return true;

            if (validationPassed) {
                const payload = { job_id: deal_id, RequestType: 'Resupply', ResupplyDetailsID: requestId, result: cleanedData };
                setShowLoader(true);
                const res = await saveEqipment(localStorage.access_token, payload, countryId);
                setShowLoader(false);
                if (res?.status === 200 && res.data?.status_code === 200) {
                    toast.success(res.data?.result.message || "Equipment details saved successfully!");
                    await fetchRequestOverView(); // 👈 Refresh overview
                } else {
                    toast.error("Failed to save equipment details ❌");
                    validationPassed = false;
                }
            }
        } else if (activeTab === 'house') {
            const payload = {
                job_id: deal_id,
                RequestType: 'Resupply',
                ResupplyDetailsID: requestId,
                items: houses
                    .map(item => ({
                        ID: item.ID ?? null,
                        Hose_Type: item.houseType ?? '',
                        Section_Length: item.sectionLength ?? null,
                        End_Fittings_1: item.endFittingType1 ?? '',
                        End_Fittings_2: item.endFittingType2 ?? '',
                        Quantity: Number(item.quantity) || null,
                        Supplied_By: typeof item.suppliedBy === 'object' ? item.suppliedBy?.value : item.suppliedBy ?? '',
                        Hose_Diameter: Number(item.houseDiameter) || null,
                    }))
                    .filter(obj => Object.values(obj).some(v => v !== null && v !== "" && v !== undefined && v !== 0))
            };

            if (payload.items.length === 0) return true;

            for (let i = 0; i < houses.length; i++) {
                const item = houses[i];
                const fields = ['houseType', 'sectionLength', 'houseDiameter', 'endFittingType1', 'endFittingType2'];
                const anyFilled = fields.some(f => item[f] !== undefined && item[f] !== null && item[f] !== "");
                if (anyFilled) {
                    const missing = fields.filter(f => !item[f] || item[f] === "");
                    if (missing.length) {
                        toast.warning("Hose Type, Section Length, Hose Diameter, End Fitting Type1, End Fitting Type2 are required.", { autoClose: 8000 });
                        validationPassed = false;
                        return validationPassed;
                    }
                }
            }

            try {
                setShowLoader(true);
                const res = await saveHose(localStorage.access_token, payload, countryId);
                setShowLoader(false);
                if (res.status === 200 && res.data?.status_code === 200) {
                    toast.success(res.data?.result.message || "Hose details saved successfully!");
                    await fetchRequestOverView(); // 👈 Refresh overview
                } else {
                    toast.error("Failed to save hose details ❌");
                    validationPassed = false;
                }
            } catch (error) {
                setShowLoader(false);
                toast.error("Something went wrong while saving hoses.");
                validationPassed = false;
            }
        } else if (activeTab === 'items') {
            const extractValidItems = (items) => {
                return (items || [])
                    .filter(item => {
                        const hasQty = item.Quantity !== null && item.Quantity !== "" && item.Quantity !== 0;
                        const hasSupp = item.SuppliedBy !== null && item.SuppliedBy !== "";
                        return hasQty || hasSupp;
                    })
                    .map(item => ({
                        ID: item.ID ?? 0,
                        Item_Details_ID: item.ItemDetailsID ?? 0,
                        Requested_Quantity: item.Quantity ?? 0,
                        Supplied_By: item.SuppliedBy ?? ""
                    }));
            };

            const output = itemsData?.result?.flatMap(category => {
                const main = extractValidItems(category.items);
                const sub = (category.SubCategory || []).flatMap(sub => extractValidItems(sub.items));
                return [...main, ...sub];
            }) || [];

            const payload = { job_id: deal_id, RequestType: "Resupply", ResupplyDetailsID: requestId, items: output };
            setShowLoader(true);
            const res = await saveItems(localStorage.access_token, payload, countryId);
            setShowLoader(false);
            if (res.status === 200 && res.data?.status_code === 200) {
                toast.success(res.data?.result.message || "Items details saved successfully!");
                await fetchRequestOverView(); // 👈 Refresh overview
            } else {
                toast.error("Failed to save items details ❌");
                validationPassed = false;
            }
        } else if (activeTab === 'custom') {
            const hasInvalid = customPackages.some(item => {
                const hasName = !!item.itemName?.trim();
                const hasQty = Number(item.quantity) > 0;
                return (hasName || hasQty) && !(hasName && hasQty);
            });
            if (hasInvalid) {
                toast.warning("Item Name and Quantity must be filled together.", { autoClose: 8000 });
                validationPassed = false;
                return validationPassed;
            }

            const payload = {
                job_id: deal_id,
                RequestType: 'Resupply',
                ResupplyDetailsID: requestId,
                items: customPackages.map(item => ({
                    ID: item.ID ?? 0,
                    Item_Name: item.itemName ?? '',
                    Requested_Quantity: Number(item.quantity) || 0,
                    Supplied_By: item.suppliedBy,
                    Notes: item.notes ?? '',
                })),
            };

            try {
                setShowLoader(true);
                const res = await saveCustomPackageItems(localStorage.access_token, payload, countryId);
                setShowLoader(false);
                if (res.status === 200 && res.data?.status_code === 200) {
                    toast.success(res.data?.result?.message || "Custom packages saved successfully!");
                    await fetchRequestOverView(); // 👈 Refresh overview
                } else {
                    toast.error("Failed to save custom packages ❌");
                    validationPassed = false;
                }
            } catch (error) {
                setShowLoader(false);
                toast.error("Something went wrong while saving custom packages.");
                validationPassed = false;
            }
        } else if (activeTab === "lap") {
            const filtered = labItems.filter(item => item.quantity || item.suppliedBy);
            const payload = {
                job_id: deal_id,
                RequestType: 'Resupply',
                ResupplyDetailsID: requestId,
                items: filtered.map(item => ({
                    ID: item.ID ?? 0,
                    Lab_Items_ID: item.LabItemsID ?? null,
                    Requested_Quantity: item.quantity ?? 0,
                    Supplied_By: item.suppliedBy ?? "",
                })),
            };

            try {
                setShowLoader(true);
                const res = await saveLabItems(localStorage.access_token, payload, countryId);
                setShowLoader(false);
                if (res.status === 200 && res.data?.status_code === 200) {
                    toast.success(res.data?.result?.message || "Lab items saved successfully!");
                    await fetchRequestOverView(); // 👈 Refresh overview
                } else {
                    toast.error("Failed to save lab items ❌");
                    validationPassed = false;
                }
            } catch (error) {
                setShowLoader(false);
                toast.error("Something went wrong while saving lab items.");
                validationPassed = false;
            }
        } else if (activeTab === 'hse') {
            const filtered = hseItems
                .filter(item => item.HSEItemID || item.quantity || item.suppliedBy || item.Notes)
                .map(item => ({
                    ID: item.ID ?? 0,
                    HSE_Items_ID: item.HSEItemID ?? 0,
                    Requested_Quantity: Number(item.quantity) || 0,
                    Supplied_By: typeof item.suppliedBy === 'object' ? item.suppliedBy.value : item.suppliedBy ?? '',
                    Notes: item.Notes
                }))
                .filter(item => item.Requested_Quantity > 0 || item.Supplied_By !== '' || item.Notes !== '');

            const payload = { job_id: deal_id, RequestType: 'Resupply', ResupplyDetailsID: requestId, items: filtered };

            try {
                setShowLoader(true);
                const res = await saveHSE(localStorage.access_token, payload, countryId);
                setShowLoader(false);
                if (res.status === 200 && res.data?.status_code === 200) {
                    toast.success(res.data?.result?.message || "HSE items saved successfully!");
                    await fetchRequestOverView(); // 👈 Refresh overview
                } else {
                    toast.error("Failed to save HSE items ❌");
                    validationPassed = false;
                }
            } catch (error) {
                setShowLoader(false);
                toast.error("Something went wrong while saving HSE items.");
                validationPassed = false;
            }
        } else if (activeTab === '3rdParty') {
            const output = thirdParty
                .map(item => ({
                    ID: item.ID || null,
                    BCR_ID: item.BCR_ID || null,
                    Requested_Quantity: Number(item.Quantity) || null,
                    Supplied_By: item.SuppliedBy || ""
                }))
                .filter(item => item.Requested_Quantity !== null || item.Supplied_By !== "");

            const payload = { job_id: deal_id, RequestType: 'Resupply', items: output };
            setShowLoader(true);
            const res = await save3rdParty(localStorage.access_token, payload, countryId);
            setShowLoader(false);
            if (res.status === 200 && res.data?.status_code === 200) {
                toast.success(res.data?.result?.message || "3rdParty items saved successfully!");
                await fetchRequestOverView(); // 👈 Refresh overview
            } else {
                toast.error("Failed to save 3rdParty items ❌");
                validationPassed = false;
            }
        }

        return validationPassed;
    }, [activeTab, equipments, houses, customPackages, labItems, hseItems, thirdParty, itemsData, deal_id, countryId, requestId, fetchRequestOverView]);

    const handleResupplyRequest = useCallback(async () => {
        const errors = {};
        if (!reRequestDetails?.Needed_On) errors.Needed_On = 'Needed On date is required.';
        if (!reRequestDetails?.Status) errors.Status = 'Please select a Status.';
        if (!reRequestDetails?.priority) errors.priority = 'Please select a Priority.';
        if (Object.keys(errors).length > 0) {
            setResupplyErrors(errors);
            return;
        }
        setResupplyErrors({});
        setIsRequesting(true);
        const payload = {
            JobDetails_ID: deal_id,
            Needed_On: reRequestDetails.Needed_On,
            Status: reRequestDetails.Status.value,
            priority: reRequestDetails.priority.label,
            comments: null
        };
        const res = await postReSupplyRequest(payload, localStorage.access_token);
        setIsRequesting(false);
        if (res?.data?.data?.status_code === 200) {
            toast.success(res.data.data.message);
            setTimeout(() => navigate(`/home/${deal_id}/${res.data.data.Request_ID}/${countryId}`), 2000);
        } else if (res?.data?.data?.status_code === 403) {
            toast.error(res.data.data.message);
        }
    }, [deal_id, reRequestDetails, navigate, countryId]);

    const handleSubmitApproval = useCallback(async () => {
        let statusId = statusList.find(({ label }) => label == "Approved").value;
        setShowLoader(true);
        const payload = {
            "JobDetails_ID": deal_id,
            "Request_ID": requestId,
            "Needed_On": reRequestDetails.Needed_On,
            "Status": statusId,
            "priority": reRequestDetails?.priority,
            "comments": "",
            "Expected_Delivery_Date": reRequestDetails?.Expected_Delivery_Date ?? ""
        };
        const res = await updateReSupplyRequest(payload, localStorage.access_token);
        fetchRequestOverView();
        setShowLoader(false);
        if (res?.data?.data?.status_code === 200) {
            toast.success(res.data.data.message);
        } else if (res?.data?.data?.status_code === 403) {
            toast.error(res.data.data.message);
        }
    }, [deal_id, requestId, reRequestDetails, statusList, fetchRequestOverView]);

    const handleBasicInfoUpdate = useCallback(async () => {
        let statusId = statusList.find(({ label }) => label === "Request Raised").value;
        setShowLoader(true);
        const payload = {
            "JobDetails_ID": deal_id,
            "Request_ID": requestId,
            "Needed_On": reRequestDetails.Needed_On,
            "Status": statusId,
            "priority": reRequestDetails?.priority,
            "comments": "",
            "Expected_Delivery_Date": reRequestDetails?.Expected_Delivery_Date ?? ""
        };
        const res = await updateReSupplyRequest(payload, localStorage.access_token);
        setShowLoader(false);
        if (res?.data?.data?.status_code === 200) {
            toast.success(res.data.data.message);
        } else if (res?.data?.data?.status_code === 403) {
            toast.error(res.data.data.message);
        }
    }, [deal_id, requestId, reRequestDetails, statusList]);

    const handleSummaryClick = useCallback(() => {
        let url = `/summary/${hs_deal_id}/${deal_id}/${requestId}/${countryId}`;
        navigate(url);
    }, [hs_deal_id, deal_id, requestId, countryId, navigate]);

    const handleRequestClick = useCallback(() => navigate('/resupply'), [navigate]);

    const onClose = useCallback(() => setAssetReset(false), []);
    const onDeleteClose = useCallback(() => setAssetDelete(false), []);
    const onConfirm = useCallback((type, selectedOption, index, supplyChain) => {
        setAssetReset(false);
        handleSelectChange(type, selectedOption, index, supplyChain);
    }, [handleSelectChange]);

    // --- Memoized selectors for equipment table ---
    const getAllSelectedAssetNumbers = useCallback(() => {
        const all = new Set();
        equipments.forEach(item => {
            item?.Assets?.forEach(asset => {
                asset?.AssetDetails?.forEach(detail => {
                    if (detail?.value) all.add(detail.value);
                });
            });
        });
        return Array.from(all);
    }, [equipments]);

    const getFilteredOptionsForEquipment = useCallback((val, index) => {
        const selectedAssetTypes = equipments
            .filter((item, idx) => idx !== index && item.supplyChainAssetType)
            .map(item => item.supplyChainAssetType);
        const options = val?.AssetSubType?.length ? val.AssetSubType : suppliedChainOptions;
        return options.map(option => ({
            ...option,
            isDisabled: selectedAssetTypes.includes(option.value) && option.value !== val.supplyChainAssetType
        }));
    }, [equipments, suppliedChainOptions]);

    const getFilteredAssetNumbers = useCallback((val, assetIndex) => {
        if (!raNumbers?.length) return raNumbers;
        const selectedAssetNumbers = getAllSelectedAssetNumbers();
        const currentSelected = val?.Assets[assetIndex]?.AssetDetails
            ?.filter(d => d?.value).map(d => d.value) || [];
        return raNumbers.map(option => ({
            ...option,
            isDisabled: selectedAssetNumbers.includes(option.value) && !currentSelected.includes(option.value)
        }));
    }, [raNumbers, getAllSelectedAssetNumbers]);

    const getEquipmentAssetDetailsCount = useCallback((equipmentIndex) => {
        return equipments[equipmentIndex].Assets.reduce(
            (sum, asset) => sum + (asset.AssetDetails?.filter(a => a.value !== null).length || 0), 0
        );
    }, [equipments]);

    const isFieldDisabled = (tab, field, val) => {
        // const status = reRequestDetails?.Status;
        const status = val?.Status;
        const currentRole = role.toLowerCase();

        // const EDITABLE_STATUSES = new Set(['Not Started', 'Request Raised', 'Approved', 'Partial Deployed']);
        const NON_EDITABLE_STATUSES = new Set(['Deployed']);
        const GENERAL_ROLES = new Set(['field tech', 'field leader', 'area manager']);
        const LEADER_ROLES = new Set(['field leader', 'area manager']);
        const SCM_ROLE = 'supply chain';

        // ----- Now status is editable; apply role-based restrictions -----
        if (tab === 'equipment') {

            if (status && NON_EDITABLE_STATUSES.has(status)) {
                return true; // disabled
            }
            // Fields that only Supply Chain can edit
            if (field === 'SuppliedBy' || field === 'assetNumber' || field === 'SpareCount' ||
                field === 'NonBillableCount' || field === 'SuppliedQuantity' || field === 'expectedAvailableDate') {
                return currentRole !== SCM_ROLE;
            }

            if (field === 'approvedQuantity') {
                return !LEADER_ROLES.has(currentRole);
            }

            if (field === 'supplyChainAssetType') {
                return !GENERAL_ROLES.has(currentRole);
            }

            // requestedQuantity: editable by non‑general roles only
            if (field === 'requestedQuantity') {
                return !GENERAL_ROLES.has(currentRole); // disabled if general
            }
        }
        else if (tab == 'hose') {
            if (status && NON_EDITABLE_STATUSES.has(status)) {
                return true; // disabled
            }
            if (field === 'suppliedBy') {
                return currentRole !== SCM_ROLE;
            }
        }
        else if (tab == 'item') {
            if (status && NON_EDITABLE_STATUSES.has(status)) {
                return true; // disabled
            }
            if (field === 'SuppliedBy') {
                return currentRole !== SCM_ROLE;
            }
        }
        else if (tab == 'lab') {
            if (status && NON_EDITABLE_STATUSES.has(status)) {
                return true; // disabled
            }
            if (field == 'suppliedBy') {
                return currentRole !== SCM_ROLE;
            }
        }
        else if (tab == 'hse') {
            if (status && NON_EDITABLE_STATUSES.has(status)) {
                return true; // disabled
            }
            if (field == 'suppliedBy') {
                return currentRole !== SCM_ROLE;
            }
        }
        else if (tab == 'custom') {
            if (status && NON_EDITABLE_STATUSES.has(status)) {
                return true; // disabled
            }
            if (field == 'suppliedBy') {
                return currentRole !== SCM_ROLE;
            }
        }
        else {
            return false;
        }


    };

    // --- Render ---
    return (
        <>
            <div className="wrapper">
                {showLoader && <FullScreenLoader />}
                <Header />
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                    draggable
                    theme="colored"
                />
                <div className="full-assets-mange pt-0">
                    <Container fluid>
                        <Row>
                            <Col xs='12'>
                                <div className="position-relative top-style-head pt-3 pb-3">
                                    <div className="heading-area d-flex flex-wrap align-items-center justify-content-between mb-3">
                                        <div className="d-flex flex-wrap align-items-center">
                                            <h2 className="title-h2 mb-0">Resupply Request</h2>
                                        </div>
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-web-resupply-request"
                                                onClick={handleRequestClick}
                                            >
                                                <img src={requestIcon} className="me-2" alt="" />
                                                Requests List
                                            </button>
                                        </div>
                                    </div>
                                    <div className="manage-card-bsx mb-4">
                                        <Card className="card-assets-bxs">
                                            <Card.Body className="p-2">
                                                <Row>
                                                    <Col xs={12} md={4} lg={3}>
                                                        <div className="data-flex-nm d-flex align-items-center mb-3 mb-md-0">
                                                            <div className="icon-jb-web"><img src={dataNameIcon} alt="" /></div>
                                                            <div className="manage-grop--wp mb-0 ps-2">
                                                                <h4 className="title-h4-labl">Job Name</h4>
                                                                <p className="shrt-line-txtwts">{requestBasicInfo?.JobName}</p>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                        <div className="manage-grop--wp mb-3 mb-md-0">
                                                            <h4 className="title-h4-labl">Customer Name</h4>
                                                            <p className="shrt-line-txtwts">{requestBasicInfo?.CustomerName}</p>
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} md={4} lg={3}>
                                                        <div className="manage-grop--wp mb-0">
                                                            <h4 className="title-h4-labl">Primary Basin</h4>
                                                            <p className="shrt-line-txtwts">{requestBasicInfo?.PrimaryBasin}</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </div>

                                    <div className="manage-select-elements mb-4">
                                        <Row className="g-3 align-items-end">
                                            <Col xs={12} sm={6} md={2} lg={2}>
                                                <Form.Group className="mb-0">
                                                    <Form.Label className="label-txt-mange">Needed on Site By</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            disabled
                                                            onChange={(e) => handleReDetailsChange(e, 'date')}
                                                            type="date"
                                                            className="control-field-txt"
                                                            name="Needed_On"
                                                            value={reRequestDetails?.Needed_On || ''}
                                                        />
                                                        <span className="input-icon">
                                                            <img src={calendarIcon} alt="" />
                                                        </span>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} sm={6} md={2} lg={2}>
                                                <Form.Group className="mb-0">
                                                    <Form.Label className="label-txt-mange">Status</Form.Label>
                                                    <div className="position-relative">
                                                        <Select
                                                            isDisabled
                                                            onChange={(e) => handleReDetailsChange(e, 'Status')}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            name="Status"
                                                            value={statusList.find(opt => opt.label === reRequestDetails?.Status)}
                                                            options={statusList}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>

                                            <Col xs={12} sm={6} md={2} lg={2}>
                                                <Form.Group className="mb-0">
                                                    <Form.Label className="label-txt-mange">Priority</Form.Label>
                                                    <div className="position-relative">
                                                        <Select
                                                            isDisabled
                                                            onChange={(e) => handleReDetailsChange(e, 'priority')}
                                                            className="basic-single"
                                                            classNamePrefix="select"
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            name="priority"
                                                            value={priorityOptions.find(opt => opt.label === reRequestDetails?.priority)}
                                                            options={priorityOptions}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} sm={6} md={2} lg={2}>
                                                <Form.Group className="mb-0">
                                                    <Form.Label className="label-txt-mange">Requested By</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            disabled
                                                            type="text"
                                                            className="control-field-txt"
                                                            name="Needed_On"
                                                            value={`${reRequestDetails?.requestedBy?.FirstName || ''} ${reRequestDetails?.requestedBy?.LastName || ''}`.trim()}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} sm={6} md={2} lg={2}>
                                                <Form.Group className="mb-0">
                                                    <Form.Label className="label-txt-mange">Delivery Date</Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            disabled={role == 'field leader' || role == 'area manager' || role == 'supply chain' ? reRequestDetails?.Status == 'Deployed' ? true : false : true}
                                                            onChange={(e) => handleReDetailsChange(e, 'date')}
                                                            type="date"
                                                            className="control-field-txt"
                                                            name="Expected_Delivery_Date"
                                                            value={reRequestDetails?.Expected_Delivery_Date}
                                                        />
                                                        <span className="input-icon">
                                                            <img src={calendarIcon} alt="" />
                                                        </span>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} sm={6} md={2} lg={2}>
                                                <div className="d-flex align-items-end h-100">
                                                    <button
                                                        onClick={handleBasicInfoUpdate}
                                                        disabled={role == 'field leader' || role == 'area manager' || role == 'supply chain' ? reRequestDetails?.Status == 'Deployed' ? true : false : true}
                                                        type="submit"
                                                        className="btn btn-update w-100 btn-resup-request"
                                                    >
                                                        Update
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    <div className="box-assets-card">
                                        <div className="multi-buttons-wp d-flex flex-wrap align-items-center justify-content-between">
                                            <ul className="filter-tab-menu">
                                                <li className="tabmenu-itms-tbl"><span onClick={() => handleTablClick('equipment')} className="buttons-wgts-wp"><button type="button" className={`btn btn-multi-wp ${activeTab === 'equipment' ? 'active' : ''}`}>Equipment</button></span></li>
                                                <li className="tabmenu-itms-tbl"><span onClick={() => handleTablClick('house')} className="buttons-wgts-wp"><button type="button" className={`btn btn-multi-wp ${activeTab === 'house' ? 'active' : ''}`}>Hose</button></span></li>
                                                <li className="tabmenu-itms-tbl"><span onClick={() => handleTablClick('items')} className="buttons-wgts-wp"><button type="button" className={`btn btn-multi-wp ${activeTab === 'items' ? 'active' : ''}`}>Items</button></span></li>
                                                <li className="tabmenu-itms-tbl"><span onClick={() => handleTablClick('lap')} className="buttons-wgts-wp"><button type="button" className={`btn btn-multi-wp ${activeTab === 'lap' ? 'active' : ''}`}>Lab Items</button></span></li>
                                                <li className="tabmenu-itms-tbl"><span onClick={() => handleTablClick('hse')} className="buttons-wgts-wp"><button type="button" className={`btn btn-multi-wp ${activeTab === 'hse' ? 'active' : ''}`}>HSE</button></span></li>
                                                <li className="tabmenu-itms-tbl"><span onClick={() => handleTablClick('custom')} className="buttons-wgts-wp"><button type="button" className={`btn btn-multi-wp ${activeTab === 'custom' ? 'active' : ''}`}>Custom Items</button></span></li>
                                            </ul>
                                            <div className="summary-view-flx mb-2">
                                                <button onClick={handleSummaryClick} className="btn btn-view-summary"><img src={summaryIcon} alt="" className="me-2" />Summary</button>
                                                <button disabled={reRequestDetails?.Status == 'Deployed' ? true : false} onClick={handleSave} type="submit" className="btn save-submit-btn ms-2"><img src={arrowRightIcon} className="me-2" /> Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="pb-5">
                                    <div className="table-assets-chart">
                                        {activeTab === 'equipment' && (
                                            <>
                                                {isTabLoading ? (
                                                    <div className="text-center p-5"><Spinner animation="border" /></div>
                                                ) : (
                                                    <div className="chartlist-card mb-4 mb-lg-5 pb-0">
                                                        <Table responsive className="table-more-asts">
                                                            <thead className="thead-itms-wp equipment-table-head">
                                                                <tr>
                                                                    <th>Sales Asset Type</th>
                                                                    <th className="qty-wth-wps">Requested QTY</th>
                                                                    <th>Ops Asset Type</th>
                                                                    <th className="qty-wth-wps">Approved QTY</th>

                                                                    <th className="qty-wth-wps">Spare / Non Billable</th>
                                                                    <th className="qty-wth-wps">Supplied QTY</th>
                                                                    <th className="p-0">
                                                                        <div className="th-headarea-s3">
                                                                            <div className="left-headth">Supplied By<span className="tooltips-drop"><img src={exclamationIcon} alt="" /><span className="dropdown-txt-tooltips note-txt-wt">(Note : Only SCM Team can Enter)</span></span></div>
                                                                            <div className="right-headth">Asset Number(s)<span className="tooltips-drop"><img src={exclamationIcon} alt="" /><span className="dropdown-txt-tooltips note-txt-wt">(Note : Only SCM Team can Enter)</span></span></div>
                                                                        </div>
                                                                    </th>
                                                                    <th className="qty-wth-wps">Availability Date </th>
                                                                    <th className="note-txt-wt">Notes <span className="tooltips-drop"><img src={exclamationIcon} alt="" /><span className="dropdown-txt-tooltips note-txt-wt">(Note : Only SCM Team can Enter)</span></span></th>

                                                                </tr>
                                                            </thead>
                                                            <tbody className="tbody-index">
                                                                {equipments.length === 0 ? (
                                                                    <tr>
                                                                        <td colSpan="8" className="text-center p-3">
                                                                            <button onClick={() => handleAddData('equipment')} type="button" className="btn icon-btn-action">
                                                                                <img src={plusIcon} alt="Add" />
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    equipments.map((val, index) => {
                                                                        const filteredOptions = getFilteredOptionsForEquipment(val, index);
                                                                        const selectedAssetNumbers = getAllSelectedAssetNumbers();
                                                                        return (
                                                                            <tr key={val.equipment_id}>
                                                                                <td>
                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{val.AssetType || 'N/A'}</Tooltip>}>
                                                                                        <div className="form-group-col sales-type-wth">
                                                                                            <Form.Control disabled type="text" className="input-tb-txt" value={val.AssetType} name='AssetType' />
                                                                                        </div>
                                                                                    </OverlayTrigger>
                                                                                </td>
                                                                                <td>
                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{val.requestedQuantity || 'N/A'}</Tooltip>}>
                                                                                        <div className="form-group-col">
                                                                                            <Form.Control type="number" min={0} disabled={isFieldDisabled('equipment', 'requestedQuantity', val)} onChange={(e) => handleInputChange('equipment', e, index)} className="input-tb-txt" value={val.requestedQuantity} name='requestedQuantity' />
                                                                                        </div>
                                                                                    </OverlayTrigger>
                                                                                </td>
                                                                                <td>
                                                                                    <div className="form-group w-100">
                                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>{val.supplyChainAssetType || 'Select input'}</Tooltip>}>
                                                                                            <div style={{ width: "100%", minWidth: "250px" }}>
                                                                                                <Select
                                                                                                    isDisabled={isFieldDisabled('equipment', 'supplyChainAssetType', val)}
                                                                                                    isClearable
                                                                                                    classNamePrefix="react-select"
                                                                                                    className="select_itm_fld ops-assets-type-wdt"
                                                                                                    options={filteredOptions}
                                                                                                    value={
                                                                                                        val?.AssetSubType?.length
                                                                                                            ? val.AssetSubType.find(o => o.value === val.supplyChainAssetType) || null
                                                                                                            : suppliedChainOptions.find(o => o.value === val.supplyChainAssetType) || null
                                                                                                    }
                                                                                                    // onChange={(selectedOption) => {
                                                                                                    //     const hasSuppliedBy = val.Assets?.some(a => a?.SuppliedBy?.value);
                                                                                                    //     if (!hasSuppliedBy) {
                                                                                                    //         onConfirm("equipment", selectedOption, index, "supplyChainAssetType");
                                                                                                    //         return;
                                                                                                    //     }
                                                                                                    //     setPendingSelection({ type: 'equipment', selectedOption, index, supplyChain: 'supplyChainAssetType' });
                                                                                                    //     setAssetReset(true);
                                                                                                    // }}
                                                                                                    onChange={(selectedOption) => onConfirm("equipment", selectedOption, index, "supplyChainAssetType")}
                                                                                                    placeholder="Select"
                                                                                                    isSearchable={true}
                                                                                                    menuPortalTarget={document.body}
                                                                                                    menuPosition="absolute"
                                                                                                    styles={{
                                                                                                        control: (base) => ({ ...base, borderRadius: "8px", borderColor: "#ccc", minHeight: "38px", width: "100%" }),
                                                                                                        valueContainer: (base) => ({ ...base, whiteSpace: "normal", overflow: "visible" }),
                                                                                                        singleValue: (base) => ({ ...base, whiteSpace: "normal", overflow: "visible", textOverflow: "unset", position: "relative", transform: "none", top: "0" }),
                                                                                                        menu: (base) => ({ ...base, zIndex: 999999 }),
                                                                                                    }}
                                                                                                    isOptionDisabled={(option) => option.isDisabled}
                                                                                                />
                                                                                            </div>
                                                                                        </OverlayTrigger>
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{val.approvedQuantity || 'Enter input'}</Tooltip>}>
                                                                                        <div className="form-group-col">
                                                                                            <Form.Control
                                                                                                disabled={isFieldDisabled('equipment', 'approvedQuantity', val)}
                                                                                                type="number"
                                                                                                onChange={(e) => handleInputChange('equipment', e, index)}
                                                                                                className="input-tb-txt"
                                                                                                value={val.approvedQuantity}
                                                                                                min={0}
                                                                                                name='approvedQuantity'
                                                                                            />
                                                                                        </div>
                                                                                    </OverlayTrigger>
                                                                                </td>

                                                                                <td>
                                                                                    <div className={val.SuppliedQuantity > val.requestedQuantity ? 'spare-box-field' : 'spare-box-field-disabled'}>
                                                                                        <div className="input-wave--asts mb-2">
                                                                                            <span className="text-spare-label light-blue-spare"><div className="dot-circle-spare"></div>Spare</span>
                                                                                            <div className="spare-bill-ast"><input disabled={isFieldDisabled('equipment', 'SpareCount', val)} min="0" onChange={(e) => handleInputChange('adEquipment', e, index)} type="number" name="SpareCount" value={val.SpareCount} className="form-control input-bill-ast" /></div>
                                                                                        </div>
                                                                                        <div className="input-wave--asts">
                                                                                            <span className="text-spare-label light-green-spare"><div className="dot-circle-spare"></div>Non Billable</span>
                                                                                            <div className="spare-bill-ast"><input disabled={isFieldDisabled('equipment', 'NonBillableCount', val)} min="0" onChange={(e) => handleInputChange('adEquipment', e, index)} name="NonBillableCount" value={val.NonBillableCount} type="number" className="form-control input-bill-ast" /></div>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{val.SuppliedQuantity || 'Enter input'}</Tooltip>}>
                                                                                        <div className="form-group-col">
                                                                                            <Form.Control
                                                                                                disabled={isFieldDisabled('equipment', 'SuppliedQuantity', val)}
                                                                                                type="number"
                                                                                                onChange={(e) => handleInputChange('opsEquipment', e, index)}
                                                                                                className="input-tb-txt"
                                                                                                value={val.SuppliedQuantity}
                                                                                                min={0}
                                                                                                name='SuppliedQuantity'
                                                                                            />
                                                                                        </div>
                                                                                    </OverlayTrigger>
                                                                                </td>
                                                                                <td className="px-0">
                                                                                    {val?.Assets.map((ele, i) => {
                                                                                        const filteredAssetNumbers = getFilteredAssetNumbers(val, i);
                                                                                        return (
                                                                                            <div className="d-flex less-margin-8" key={`${val.supplyChainAssetType}-${index}-${i}`}>
                                                                                                <div className="form-group-col select-supp-left">
                                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{ele?.SuppliedBy?.value || 'Select input'}</Tooltip>}>
                                                                                                        <div style={{ position: 'relative', width: '100%' }}>
                                                                                                            <Select
                                                                                                                key={`supplied-by-${val.supplyChainAssetType}-${index}-${i}`}
                                                                                                                classNamePrefix="react-select"
                                                                                                                className="single-select-optn select_itm_fld"
                                                                                                                options={isBasinLoading ? [{ label: "Loading...", value: "", isDisabled: true }] : basins}
                                                                                                                isClearable={true}
                                                                                                                value={ele?.SuppliedBy?.value ? { label: ele.SuppliedBy.label, value: ele.SuppliedBy.value } : null}
                                                                                                                onMenuOpen={() => fetchBasins(val?.supplyChainAssetType)}
                                                                                                                placeholder="Select"
                                                                                                                onChange={(selectedOption) => handleSuppliedEquipment('basin', selectedOption, index, i)}
                                                                                                                isSearchable={true}
                                                                                                                isDisabled={isFieldDisabled('equipment', 'SuppliedBy', val)}
                                                                                                                menuPortalTarget={document.body}
                                                                                                                menuPosition="absolute"
                                                                                                                styles={{
                                                                                                                    control: (base) => ({ ...base, borderRadius: "8px", borderColor: "#ccc", minHeight: "38px" }),
                                                                                                                    menu: (base) => ({ ...base, zIndex: 1 }),
                                                                                                                }}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </OverlayTrigger>
                                                                                                </div>
                                                                                                <div className="form-group-col select-supp-right d-flex" style={{ width: '100%', minWidth: 0 }}>
                                                                                                    <div className="select-assets-number" style={{ flex: 1, minWidth: 0, width: '100%' }}>
                                                                                                        <CustomMultiSelectDropdown
                                                                                                            key={`asset-details-${val.supplyChainAssetType}-${index}-${i}-${ele.assetKey || 0}`}
                                                                                                            className="inside-border-inpt select_itm_fld"
                                                                                                            options={isBasinLoading ? [{ label: "Loading...", value: "", isDisabled: true }] : filteredAssetNumbers}
                                                                                                            value={(ele?.AssetDetails || []).filter(item => item?.value && item?.label)}
                                                                                                            onChange={(selectedOptions) => handleSuppliedEquipment('raNumber', selectedOptions, index, i)}
                                                                                                            onMenuOpen={() => fetchRsNumber(val?.supplyChainAssetType, ele?.SuppliedBy?.value, index, i)}
                                                                                                            placeholder="Select"
                                                                                                            isSearchable
                                                                                                            isDisabled={isFieldDisabled('equipment', 'assetNumber', val)}
                                                                                                            isLoading={isBasinLoading}
                                                                                                            menuPosition="absolute"
                                                                                                            isOptionDisabled={(option) => option.isDisabled}
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                                </td>
                                                                                <td>
                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{val.expectedAvailableDate || 'Enter input'}</Tooltip>}>
                                                                                        <div className="form-group-col">
                                                                                            <Form.Control
                                                                                                disabled={
                                                                                                    isFieldDisabled('equipment', 'expectedAvailableDate', val)
                                                                                                }
                                                                                                type="date"
                                                                                                onChange={(e) => handleInputChange('equipment', e, index)}
                                                                                                className="input-tb-txt"
                                                                                                value={val?.expectedAvailableDate ? val.expectedAvailableDate.split("T")[0] : ""}
                                                                                                min={0}
                                                                                                name='expectedAvailableDate'
                                                                                            />
                                                                                        </div>
                                                                                    </OverlayTrigger>
                                                                                </td>
                                                                                <td>
                                                                                    <div className="d-flex align-items-center">
                                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>{val.Notes || 'Enter input'}</Tooltip>}>
                                                                                            <div className="form-grop-notes-flx">
                                                                                                <Form.Control
                                                                                                    disabled={isFieldDisabled('equipment', 'Notes', val)}
                                                                                                    type="text"
                                                                                                    onChange={(e) => handleInputChange('equipment', e, index)}
                                                                                                    className="input-tb-txt"
                                                                                                    value={val.Notes}
                                                                                                    name='Notes'
                                                                                                />
                                                                                            </div>
                                                                                        </OverlayTrigger>
                                                                                        <div className="d-flex align-items-center button-wt-action notes-butn-wts">
                                                                                            {
                                                                                                reRequestDetails?.Status == 'Deployed' || reRequestDetails?.Status == 'Partial Deployed' ?
                                                                                                    null
                                                                                                    :
                                                                                                    <>
                                                                                                        {!val.isDeployed && (
                                                                                                            <button onClick={() => handleRemoveData('equipment', val)} type="button" className="btn icon-btn-action">
                                                                                                                <img src={minusIcon} alt="icon" />
                                                                                                            </button>
                                                                                                        )}
                                                                                                        {index === equipments.length - 1 && (
                                                                                                            <button onClick={() => handleAddData('equipment')} type="button" className="btn icon-btn-action">
                                                                                                                <img src={plusIcon} alt="icon" />
                                                                                                            </button>
                                                                                                        )}
                                                                                                    </>
                                                                                            }


                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                )}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {activeTab === 'house' && (
                                            <>
                                                {isTabLoading ? (
                                                    <div className="text-center p-5"><Spinner animation="border" /></div>
                                                ) : (
                                                    <div className="chartlist-card mb-4 mb-lg-5 pb-0">
                                                        <Table responsive className="table-more-asts">
                                                            <thead className="thead-itms-wp">
                                                                <tr>
                                                                    <th>Hose Type</th>
                                                                    <th>Hose Diameter <span className="small-th-head">( Inches)</span></th>
                                                                    <th>Section Length <span className="small-th-head">(Feet)</span></th>
                                                                    <th>End-Fitting Type 1</th>
                                                                    <th>End-Fitting Type 2</th>
                                                                    <th>Quantity</th>
                                                                    <th>Supplied By</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {houses.length === 0 ? (
                                                                    <tr>
                                                                        <td colSpan="7" className="text-center p-3">
                                                                            <button onClick={() => handleAddData('house')} type="button" className="btn icon-btn-action">
                                                                                <img src={plusIcon} alt="Add" />
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    houses.map((val, index) => (
                                                                        <tr key={index}>
                                                                            <td>
                                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{val.houseType || 'Select input'}</Tooltip>}>
                                                                                    <div className="hose-select-wps">
                                                                                        <CreatableSelect
                                                                                            isDisabled={isFieldDisabled('hose', 'houseType', val)}
                                                                                            classNamePrefix="react-select"
                                                                                            className="select_itm_fld"
                                                                                            options={housesOptions}
                                                                                            value={housesOptions.find(o => o.label === val.houseType) || (val.houseType ? { label: val.houseType, value: val.houseType } : null)}
                                                                                            onChange={(selectedOption) => handleSelectChange("house", selectedOption, index, "houseType")}
                                                                                            onCreateOption={(inputValue) => handleCreateHouseOption(inputValue, index)}
                                                                                            placeholder="Select or create..."
                                                                                            isSearchable
                                                                                            isClearable
                                                                                            menuPortalTarget={document.body}
                                                                                            menuPosition="absolute"
                                                                                        />
                                                                                    </div>
                                                                                </OverlayTrigger>
                                                                            </td>
                                                                            <td>
                                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{val.houseDiameter || 'Enter input'}</Tooltip>}>
                                                                                    <div className="form-group-col">
                                                                                        <Form.Control disabled={isFieldDisabled('hose', 'houseDiameter', val)} type="number" min={0} className="input-tb-txt" onChange={(e) => handleInputChange('house', e, index)} name='houseDiameter' value={val.houseDiameter} />
                                                                                    </div>
                                                                                </OverlayTrigger>
                                                                            </td>
                                                                            <td>
                                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{val.sectionLength || 'Enter input'}</Tooltip>}>
                                                                                    <div className="form-group-col">
                                                                                        <Form.Control disabled={isFieldDisabled('hose', 'sectionLength', val)} type="number" min={0} className="input-tb-txt" onChange={(e) => handleInputChange('house', e, index)} name='sectionLength' value={val.sectionLength} />
                                                                                    </div>
                                                                                </OverlayTrigger>
                                                                            </td>
                                                                            <td>
                                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{val.endFittingType1 || 'Enter input'}</Tooltip>}>
                                                                                    <div className="form-group-col">
                                                                                        <CreatableSelect
                                                                                            isDisabled={isFieldDisabled('hose', 'endFittingType1', val)}
                                                                                            classNamePrefix="react-select"
                                                                                            className="select_itm_fld"
                                                                                            options={fittingOptions}
                                                                                            value={fittingOptions.find(o => o.label === val.endFittingType1) || (val.endFittingType1 ? { label: val.endFittingType1, value: val.endFittingType1 } : null)}
                                                                                            onChange={(selectedOption) => handleSelectChange("houseFitting1", selectedOption, index, "endFittingType1")}
                                                                                            onCreateOption={(inputValue) => handleCreateFittingOption(inputValue, index)}
                                                                                            placeholder="Select or create..."
                                                                                            isSearchable
                                                                                            isClearable
                                                                                            menuPortalTarget={document.body}
                                                                                            menuPosition="absolute"
                                                                                        />
                                                                                    </div>
                                                                                </OverlayTrigger>
                                                                            </td>
                                                                            <td>
                                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{val.endFittingType2 || 'Enter input'}</Tooltip>}>
                                                                                    <div className="form-group-col">
                                                                                        <CreatableSelect
                                                                                            isDisabled={isFieldDisabled('hose', 'endFittingType2', val)}
                                                                                            classNamePrefix="react-select"
                                                                                            className="select_itm_fld"
                                                                                            options={fittingOptions}
                                                                                            value={fittingOptions.find(o => o.label === val.endFittingType2) || (val.endFittingType2 ? { label: val.endFittingType2, value: val.endFittingType2 } : null)}
                                                                                            onChange={(selectedOption) => handleSelectChange("houseFitting2", selectedOption, index, "endFittingType2")}
                                                                                            onCreateOption={(inputValue) => handleCreateFittingOption2(inputValue, index)}
                                                                                            placeholder="Select or create..."
                                                                                            isSearchable
                                                                                            isClearable
                                                                                            menuPortalTarget={document.body}
                                                                                            menuPosition="absolute"
                                                                                        />
                                                                                    </div>
                                                                                </OverlayTrigger>
                                                                            </td>
                                                                            <td>
                                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{val.quantity || 'Enter input'}</Tooltip>}>
                                                                                    <div className="form-group-col">
                                                                                        <Form.Control disabled={isFieldDisabled('hose', 'quantity', val)} type="number" min={0} className="input-tb-txt" onChange={(e) => handleInputChange('house', e, index)} name='quantity' value={val.quantity} />
                                                                                    </div>
                                                                                </OverlayTrigger>
                                                                            </td>
                                                                            <td>
                                                                                <div className="d-flex align-items-center">
                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{val?.suppliedBy?.value || 'Select input'}</Tooltip>}>
                                                                                        <div className="form-group-col select-supp-by-wth">
                                                                                            <Select
                                                                                                isDisabled={isFieldDisabled('hose', 'suppliedBy', val)}
                                                                                                isClearable
                                                                                                classNamePrefix="react-select"
                                                                                                className="select_itm_fld"
                                                                                                options={basinsOptions}
                                                                                                value={val.suppliedBy}
                                                                                                onChange={(selectedOption) => handleSelectChange('houseSupplied', selectedOption, index, 'suppliedBy')}
                                                                                                placeholder="Select"
                                                                                                isSearchable={true}
                                                                                                menuPortalTarget={document.body}
                                                                                                menuPosition="absolute"
                                                                                                styles={{
                                                                                                    control: (base) => ({ ...base, borderRadius: "8px", borderColor: "#ccc", minHeight: "38px" }),
                                                                                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                    </OverlayTrigger>
                                                                                    {
                                                                                        reRequestDetails?.Status == 'Deployed' || reRequestDetails?.Status == 'Partial Deployed' ?
                                                                                            null
                                                                                            :
                                                                                            <>
                                                                                                <div className="d-flex align-items-center button-wt-action">
                                                                                                    {!val.isDeployed && (index !== 0 || isHoseRowEmpty(val)) && (
                                                                                                        <button onClick={() => handleRemoveData('house', val)} type="button" className="btn icon-btn-action"><img src={minusIcon} alt="icon" /></button>
                                                                                                    )}
                                                                                                    {index === houses.length - 1 && (
                                                                                                        <button onClick={() => handleAddData('house')} type="button" className="btn icon-btn-action"><img src={plusIcon} alt="icon" /></button>
                                                                                                    )}
                                                                                                </div>
                                                                                            </>
                                                                                    }

                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                )}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {activeTab === 'items' && (
                                            <>
                                                {isTabLoading ? (
                                                    <div className="text-center p-5"><Spinner animation="border" /></div>
                                                ) : (
                                                    <div className="mb-4 mb-lg-5">
                                                        <div className="table-accordion-assets" style={{ overflow: 'visible' }}>
                                                            <Accordion>
                                                                {itemsData?.result?.map((category, categoryIndex) => (
                                                                    <Accordion.Item key={categoryIndex} className="accordion-card-itm" eventKey={categoryIndex.toString()}>
                                                                        <Accordion.Header className="heading-accordian-wp">
                                                                            {category.MasterCategory}
                                                                        </Accordion.Header>
                                                                        <Accordion.Body className="p-0">
                                                                            {Array.isArray(category.SubCategory) && category.SubCategory.length > 0 ? (
                                                                                <Accordion>
                                                                                    {category.SubCategory.map((subCategory, subCategoryIndex) => (
                                                                                        <Accordion.Item key={subCategoryIndex} className="item-accordian-lst" eventKey={subCategoryIndex.toString()}>
                                                                                            <Accordion.Header>{subCategory.MasterCategory}</Accordion.Header>
                                                                                            <Accordion.Body className="p-0">
                                                                                                <Table responsive className="table-more-asts" style={{ overflow: 'visible' }}>
                                                                                                    <thead className="thead-itms-wp items-headwp">
                                                                                                        <tr>
                                                                                                            <th>Item Name</th>
                                                                                                            <th>Quantity <span className="small-th-head">(Requested)</span></th>
                                                                                                            <th className="item-suplywgt-head">Supplied By</th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        {subCategory.items?.map((item, itemIndex) => (
                                                                                                            <tr key={itemIndex}>
                                                                                                                <td>
                                                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{item.ItemName || 'N/A'}</Tooltip>}>
                                                                                                                        <div className="itm-content-parg"><p className="txtweb-content">{item.ItemName}</p></div>
                                                                                                                    </OverlayTrigger>
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{item.Quantity || 'Enter input'}</Tooltip>}>
                                                                                                                        <div className="form-group-col">
                                                                                                                            <Form.Control
                                                                                                                                disabled={isFieldDisabled('item', 'Quantity', item)}
                                                                                                                                type="number"
                                                                                                                                onChange={(e) => handleItemsInputChange(categoryIndex, subCategoryIndex, itemIndex, 'Quantity', e.target.value, true)}
                                                                                                                                className="input-tb-txt"
                                                                                                                                name='quantity'
                                                                                                                                min={0}
                                                                                                                                value={item.Quantity ?? ''}
                                                                                                                            />
                                                                                                                        </div>
                                                                                                                    </OverlayTrigger>
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{item.SuppliedBy || 'Select input'}</Tooltip>}>
                                                                                                                        <div className="d-flex align-items-center">
                                                                                                                            <div className="itm-select-supply-wtm" style={{ width: '100%' }}>
                                                                                                                                <Select
                                                                                                                                    isDisabled={isFieldDisabled('item', 'SuppliedBy', item)}
                                                                                                                                    isClearable
                                                                                                                                    classNamePrefix="react-select"
                                                                                                                                    className="select_itm_fld"
                                                                                                                                    options={basinsOptions}
                                                                                                                                    value={basinsOptions.find(option => option.value === item.SuppliedBy) || null}
                                                                                                                                    onChange={(value) => handleItemsInputChange(categoryIndex, subCategoryIndex, itemIndex, 'SuppliedBy', value, true)}
                                                                                                                                    placeholder="Select"
                                                                                                                                    isSearchable={true}
                                                                                                                                    menuPortalTarget={document.body}
                                                                                                                                    menuPosition="absolute"
                                                                                                                                    styles={{
                                                                                                                                        control: (base) => ({ ...base, borderRadius: "8px", borderColor: "#ccc", minHeight: "38px" }),
                                                                                                                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                                                                                    }}
                                                                                                                                />
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </OverlayTrigger>
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        ))}
                                                                                                    </tbody>
                                                                                                </Table>
                                                                                            </Accordion.Body>
                                                                                        </Accordion.Item>
                                                                                    ))}
                                                                                </Accordion>
                                                                            ) : (
                                                                                <Table responsive className="table-more-asts" style={{ overflow: 'visible' }}>
                                                                                    <thead className="thead-itms-wp items-headwp">
                                                                                        <tr>
                                                                                            <th>Item Name</th>
                                                                                            <th>Quantity <span className="small-th-head">(Requested)</span></th>
                                                                                            <th className="item-suplywgt-head">Supplied By</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {category.items?.map((item, itemIndex) => (
                                                                                            <tr key={itemIndex}>
                                                                                                <td>
                                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{item.ItemName || 'N/A'}</Tooltip>}>
                                                                                                        <div className="itm-content-parg"><p className="txtweb-content">{item.ItemName}</p></div>
                                                                                                    </OverlayTrigger>
                                                                                                </td>
                                                                                                <td>
                                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{item.Quantity || 'Enter input'}</Tooltip>}>
                                                                                                        <div className="form-group-col">
                                                                                                            <Form.Control
                                                                                                                disabled={isFieldDisabled('item', 'Quantity2', item)}
                                                                                                                type="number"
                                                                                                                min={0}
                                                                                                                onChange={(e) => handleItemsInputChange(categoryIndex, itemIndex, null, 'Quantity', e.target.value)}
                                                                                                                className="input-tb-txt"
                                                                                                                name='quantity'
                                                                                                                value={item.Quantity ?? ''}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </OverlayTrigger>
                                                                                                </td>
                                                                                                <td>
                                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>{item.SuppliedBy || 'Select input'}</Tooltip>}>
                                                                                                        <div className="d-flex align-items-center">
                                                                                                            <div className="itm-select-supply-wtm" style={{ width: '100%' }}>
                                                                                                                <Select
                                                                                                                    isDisabled={isFieldDisabled('item', 'SuppliedBy2', item)}
                                                                                                                    isClearable
                                                                                                                    classNamePrefix="react-select"
                                                                                                                    className="select_itm_fld"
                                                                                                                    options={basinsOptions}
                                                                                                                    value={basinsOptions.find(option => option.value === item.SuppliedBy) || null}
                                                                                                                    onChange={(value) => handleItemsInputChange(categoryIndex, itemIndex, null, 'SuppliedBy', value)}
                                                                                                                    placeholder="Select"
                                                                                                                    isSearchable={true}
                                                                                                                    menuPortalTarget={document.body}
                                                                                                                    menuPosition="absolute"
                                                                                                                    styles={{
                                                                                                                        control: (base) => ({ ...base, borderRadius: "8px", borderColor: "#ccc", minHeight: "38px" }),
                                                                                                                        menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                                                                    }}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </OverlayTrigger>
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </Table>
                                                                            )}
                                                                        </Accordion.Body>
                                                                    </Accordion.Item>
                                                                ))}
                                                            </Accordion>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {activeTab === 'custom' && (
                                            <>
                                                {isTabLoading ? (
                                                    <div className="text-center p-5"><Spinner animation="border" /></div>
                                                ) : (
                                                    <div className="mb-4 mb-lg-5">
                                                        <Table responsive className="table-more-asts">
                                                            <thead className="thead-itms-wp">
                                                                <tr>
                                                                    <th>Item Name</th>
                                                                    <th>Quantity <span className="small-th-head">(Requested)</span></th>
                                                                    <th className="supply-by-thead">Supplied By</th>
                                                                    <th>Notes</th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="td-align-wt">
                                                                {customPackages.length === 0 ? (
                                                                    <tr>
                                                                        <td colSpan="5" className="text-center p-3">
                                                                            <button onClick={() => handleAddData('custom')} type="button" className="btn icon-btn-action">
                                                                                <img src={plusIcon} alt="Add" />
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    customPackages.map((val, index) => (
                                                                        <tr key={val.index}>
                                                                            <td>
                                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{val.itemName || 'Enter input'}</Tooltip>}>
                                                                                    <Form.Control
                                                                                        disabled={isFieldDisabled('custom', 'itemName', val)}
                                                                                        type="text"
                                                                                        name="itemName"
                                                                                        className="input-tb-txt"
                                                                                        value={val.itemName}
                                                                                        onChange={(e) => handleInputChange("custom", e, index)}
                                                                                    />
                                                                                </OverlayTrigger>
                                                                            </td>
                                                                            <td>
                                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{val.quantity || 'Enter input'}</Tooltip>}>
                                                                                    <Form.Control
                                                                                        disabled={isFieldDisabled('custom', 'quantity', val)}
                                                                                        type="number"
                                                                                        min={0}
                                                                                        name="quantity"
                                                                                        className="input-tb-txt"
                                                                                        value={val.quantity}
                                                                                        onChange={(e) => handleInputChange("custom", e, index)}
                                                                                    />
                                                                                </OverlayTrigger>
                                                                            </td>
                                                                            <td>
                                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{val.suppliedBy || 'Select input'}</Tooltip>}>
                                                                                    <div>
                                                                                        <Select
                                                                                            isDisabled={isFieldDisabled('custom', 'suppliedBy', val)}
                                                                                            isClearable
                                                                                            classNamePrefix="react-select"
                                                                                            className="select_itm_fld"
                                                                                            options={basinsOptions}
                                                                                            value={basinsOptions.find(opt => opt.value === val.suppliedBy) || null}
                                                                                            onChange={(selectedOption) => handleSelectChange('custom', selectedOption, index, 'suppliedBy')}
                                                                                            placeholder="Select"
                                                                                            isSearchable={true}
                                                                                            menuPortalTarget={document.body}
                                                                                            menuPosition="absolute"
                                                                                            styles={{
                                                                                                control: (base) => ({ ...base, borderRadius: "8px", borderColor: "#ccc", minHeight: "38px" }),
                                                                                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </OverlayTrigger>
                                                                            </td>
                                                                            <td>
                                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{val.notes || 'Enter input'}</Tooltip>}>
                                                                                    <Form.Control
                                                                                        disabled={isFieldDisabled('custom', 'notes', val)}
                                                                                        type="text"
                                                                                        name="notes"
                                                                                        value={val.notes}
                                                                                        className="input-tb-txt"
                                                                                        onChange={(e) => handleInputChange("custom", e, index)}
                                                                                    />
                                                                                </OverlayTrigger>
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    reRequestDetails?.Status == 'Deployed' || reRequestDetails?.Status == 'Partial Deployed' ?
                                                                                        null
                                                                                        :
                                                                                        <>
                                                                                            <div className="d-flex">
                                                                                                {!val.isDeployed && (
                                                                                                    <button onClick={() => handleRemoveData("custom", val)} type="button" className="btn icon-btn-action"><img src={minusIcon} alt="icon" /></button>
                                                                                                )}
                                                                                                {index === customPackages.length - 1 && (
                                                                                                    <button onClick={() => handleAddData("custom")} type="button" className="btn icon-btn-action"><img src={plusIcon} alt="icon" /></button>
                                                                                                )}
                                                                                            </div>
                                                                                        </>
                                                                                }

                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                )}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {activeTab === 'lap' && (
                                            <>
                                                {isTabLoading ? (
                                                    <div className="text-center p-5"><Spinner animation="border" /></div>
                                                ) : (
                                                    <div className="mb-4 mb-lg-5">
                                                        <Table responsive className="table-more-asts">
                                                            <thead className="thead-itms-wp">
                                                                <tr>
                                                                    <th>Item Name</th>
                                                                    <th className="qnty-reqsr-web">Quantity (Requested)</th>
                                                                    <th className="supply-by-lab">Supplied By</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="td-align-wt">
                                                                {labItems.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>{item.itemName || 'N/A'}</Tooltip>}>
                                                                                <div className="position-relative">
                                                                                    <span className="txt-conten-pargrap">{item.itemName}</span>
                                                                                </div>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                        <td>
                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>{item.quantity || 'Enter input'}</Tooltip>}>
                                                                                <div className="quanty-web-mts">
                                                                                    <Form.Control
                                                                                        disabled={isFieldDisabled('lab', 'quantity', item)}
                                                                                        name="quantity"
                                                                                        type="number"
                                                                                        min={0}
                                                                                        className="input-tb-txt"
                                                                                        value={item.quantity || ""}
                                                                                        onChange={(e) => handleInputChange("lap", e, index)}
                                                                                    />
                                                                                </div>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                        <td>
                                                                            <div className="d-flex align-items-center">
                                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{item.suppliedBy || 'Select input'}</Tooltip>}>
                                                                                    <div className="itm-select-supply-wtm">
                                                                                        <Select
                                                                                            isDisabled={isFieldDisabled('lab', 'suppliedBy', item)}
                                                                                            onChange={(val) => handleSelectChange("lapSelect", val, index, 'suppliedBy')}
                                                                                            value={basinsOptions.find(o => o.value === item.suppliedBy) || null}
                                                                                            classNamePrefix="react-select"
                                                                                            className="select_itm_fld"
                                                                                            options={basinsOptions}
                                                                                            placeholder="Select"
                                                                                            isSearchable={true}
                                                                                            isClearable
                                                                                            menuPortalTarget={document.body}
                                                                                            menuPosition="absolute"
                                                                                            styles={{
                                                                                                control: (base) => ({ ...base, borderRadius: "8px", borderColor: "#ccc", minHeight: "38px" }),
                                                                                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </OverlayTrigger>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {activeTab === 'hse' && (
                                            <>
                                                {isTabLoading ? (
                                                    <div className="text-center p-5"><Spinner animation="border" /></div>
                                                ) : (
                                                    <div className="mb-4 mb-lg-5">
                                                        <Table responsive className="table-more-asts">
                                                            <thead className="thead-itms-wp">
                                                                <tr>
                                                                    <th>Item Name</th>
                                                                    <th className="hse-qty-thead">Quantity <span className="small-th-head">(Requested)</span></th>
                                                                    <th className="supply-by-lab">Supplied By</th>
                                                                    <th className="supply-by-lab">Notes</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="td-align-wt">
                                                                {hseItems.map((val, index) => (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>{val.itemName || 'N/A'}</Tooltip>}>
                                                                                <div className="position-relative">
                                                                                    <span className="txt-conten-pargrap">{val.itemName}</span>
                                                                                </div>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                        <td>
                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>{val.quantity || 'Enter input'}</Tooltip>}>
                                                                                <div className="form-group-col">
                                                                                    <Form.Control
                                                                                        disabled={isFieldDisabled('hse', 'quantity', val)}
                                                                                        type="number"
                                                                                        className="input-tb-txt"
                                                                                        name="quantity"
                                                                                        min={0}
                                                                                        value={val.quantity || ""}
                                                                                        onChange={(e) => handleInputChange("hse", e, index)}
                                                                                    />
                                                                                </div>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                        <td>
                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>{val.suppliedBy || 'Select input'}</Tooltip>}>
                                                                                <div className="form-group-col">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <div className="itm-select-supply-wtm">
                                                                                            <Select
                                                                                                isDisabled={isFieldDisabled('hse', 'suppliedBy', val)}
                                                                                                isClearable={true}
                                                                                                classNamePrefix="react-select"
                                                                                                className="select_itm_fld"
                                                                                                options={basinsOptions}
                                                                                                value={basinsOptions.find(o => o.value === val.suppliedBy) || null}
                                                                                                onChange={(selectedOption) => handleSelectChange('hse', selectedOption, index, 'suppliedBy')}
                                                                                                placeholder="Select"
                                                                                                isSearchable={true}
                                                                                                menuPortalTarget={document.body}
                                                                                                menuPosition="absolute"
                                                                                                styles={{
                                                                                                    control: (base) => ({ ...base, borderRadius: "8px", borderColor: "#ccc", minHeight: "38px" }),
                                                                                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                        <td>
                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>{val.Notes || 'Enter input'}</Tooltip>}>
                                                                                <div className="form-group-col">
                                                                                    <Form.Control
                                                                                        disabled={isFieldDisabled('hse', 'Notes', val)}
                                                                                        type="text"
                                                                                        className="input-tb-txt"
                                                                                        name="Notes"
                                                                                        value={val.Notes || ""}
                                                                                        onChange={(e) => handleInputChange("hse", e, index)}
                                                                                    />
                                                                                </div>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {activeTab === '3rdParty' && (
                                            <>
                                                {isTabLoading ? (
                                                    <div className="text-center p-5"><Spinner animation="border" /></div>
                                                ) : (
                                                    <div className="mb-4 mb-lg-5">
                                                        <Table responsive className="table-more-asts">
                                                            <thead className="thead-itms-wp">
                                                                <tr>
                                                                    <th>Equipment Name</th>
                                                                    <th>Quantity <span className="small-th-head">(Requested)</span></th>
                                                                    <th className="supply-by-lab">Supplied By</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="td-align-wt">
                                                                {thirdParty.map((val, i) => (
                                                                    <tr key={i}>
                                                                        <td>
                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>{val.AssetName || 'Select input'}</Tooltip>}>
                                                                                <div><span className="txt-conten-pargrap">{val.AssetName}</span></div>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                        <td>
                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>{val.Quantity || 'Enter input'}</Tooltip>}>
                                                                                <div className="form-group-col">
                                                                                    <Form.Control type="number" onChange={(e) => handleInputChange("3rdParty", e, i)} name="Quantity" value={val.Quantity} min={0} className="input-tb-txt" />
                                                                                </div>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                        <td>
                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>{val.SuppliedBy || 'Enter input'}</Tooltip>}>
                                                                                <div className="form-group-col">
                                                                                    <div className="d-flex align-items-center">
                                                                                        <div className="itm-select-supply-wtm">
                                                                                            <Form.Control onChange={(e) => handleInputChange("3rdParty", e, i)} type="text" name="SuppliedBy" value={val.SuppliedBy} className="input-tb-txt" />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </OverlayTrigger>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>

            {/* Modals */}
            <Modal show={assetReset} onHide={onClose} centered>
                <Modal.Header className="modal-header-s3s" closeButton>
                    <Modal.Title>Confirm Reset</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="card-delete-wap text-center pt-3">
                        <div className="icon-notf-web mb-3"><img src={exclamationTraingleIcon} alt="" /></div>
                        <p className="txt-wgtmult-wp">This selection will reset <strong>Supplied By</strong> and <strong>Asset Number</strong>.<br /> Are you sure?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer className="pt-0 border-top-0">
                    <Button variant="secondary" className="btn-cancel-mdl" onClick={onClose}>
                        <img src={cancelIconMdl} className="me-1" alt="" />Cancel
                    </Button>
                    <Button
                        className="btn-submit-delt"
                        variant="danger"
                        onClick={() => {
                            setAssetReset(false);
                            if (pendingSelection) {
                                onConfirm(
                                    pendingSelection.type,
                                    pendingSelection.selectedOption,
                                    pendingSelection.index,
                                    pendingSelection.supplyChain
                                );
                            }
                        }}
                    >
                        <img src={deleteIconMdl} className="me-1" alt="" />
                        Yes, Reset
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={assetDelete} onHide={onDeleteClose} centered>
                <Modal.Header className="modal-header-s3s" closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="card-delete-wap text-center pt-3">
                        <div className="icon-notf-web mb-3"><img src={exclamationTraingleIcon} alt="" /></div>
                        <p className="txt-wgtmult-wp">This Item will be <strong>deleted.</strong> <br /> Are you sure?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer className="pt-0 border-top-0">
                    <Button variant="secondary" className="btn-cancel-mdl" onClick={onDeleteClose}>
                        <img src={cancelIconMdl} className="me-1" alt="" />Cancel
                    </Button>
                    <Button
                        className="btn-submit-delt"
                        variant="danger"
                        onClick={() => {
                            setAssetDelete(false);
                            hndleEquipmentDelete();
                        }}
                    >
                        <img src={deleteIconMdl} className="me-1" alt="" />
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Home;